import { Buffer } from 'buffer';
import process from 'process';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ThemeProvider } from './lib/theme';
import './styles/global.css';

// @react-pdf-renderer en yoga-wasm-base64 verwachten Node globals in browser.
// Hard-set zodat PDF-render werkt zonder Vite-plugin extras.
(globalThis as unknown as { Buffer: typeof Buffer; process: typeof process; global: typeof globalThis }).Buffer = Buffer;
(globalThis as unknown as { Buffer: typeof Buffer; process: typeof process; global: typeof globalThis }).process = process;
(globalThis as unknown as { Buffer: typeof Buffer; process: typeof process; global: typeof globalThis }).global = globalThis;

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);
